<template>
  <div>
    <VDialog v-model="receptionDialog" width="600">
      <VCard>
        <VCardTitle>{{ $t("receptionDate") }}</VCardTitle>
        <VCardText>
          <ValidationObserver ref="formObs" v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(sendReceptionDate)">
              <CustomDatePicker
                v-model="formData.guessedTakenAwayDate"
                :label="$t('date')"
                :name="$t('date')"
                class="user_input no-margin"
                rules="required"
              ></CustomDatePicker>
              <CustomInputText
                v-model="formData.count"
                :label="$t('count')"
                :rules="{ required: true, min_value: 0, max_value: maxCount }"
                class="user_input no-margin"
                @keydown="numberOnly"
              ></CustomInputText>
              <CustomTextTextarea
                v-model="formData.body"
                :label="$t('comment')"
                class="user_input"
              ></CustomTextTextarea>
              <ValidationProvider
                tag="div"
                class="mt-2"
                v-slot="{ errors }"
                :name="$t('file')"
                rules="required"
              >
                <VFileInput
                  :label="$t('file')"
                  :error-messages="errors[0]"
                  dense
                  v-model="formData.file"
                />
              </ValidationProvider>
              <div class="text-right mt-3">
                <VBtn class="mr-3" color="secondary" @click="close">{{
                  $t("toCancel")
                }}</VBtn>
                <VBtn :loading="loading" color="primary" type="submit">{{
                  $t("send")
                }}</VBtn>
              </div>
            </form>
          </ValidationObserver>
        </VCardText>
      </VCard>
    </VDialog>
    <VDialog v-model="dialog" width="600">
      <VCard>
        <VBtn
          absolute
          style="right: 0"
          class="mt-1"
          icon
          @click="dialog = false"
        >
          <VIcon>mdi-close</VIcon>
        </VBtn>
        <VCardText>
          <VCardTitle class="px-0">{{ $t("listOfVisits") }}</VCardTitle>
          <template v-if="listGiven.length">
            <div
              v-for="(item, index) in listGiven"
              :key="`listGiven-${index}`"
              class="py-2"
            >
              <VSheet
                class="rounded px-2 d-flex justify-space-between flex-wrap align-center"
                color="primary"
                dark
              >
                {{ index + 1 }}. {{ $t("date") }}:
                {{ item.guessedTakenAwayDate | dateParse }}; {{ $t("count") }}:
                {{ item.count }}
                <span v-show="item.state">{{
                  $t(`receptionStatus.${item.state}`)
                }}</span>
                <Downloader btn-class="w" :address="item.filePath" />
              </VSheet>
            </div>
          </template>
          <template v-else>
            {{ $t("noDataAvailable") }}
          </template>
          <div class="text-right">
            <VBtn color="primary" @click="receptionDialog = true"
              >{{ listGiven.length ? $t("sendAgain") : $t("send") }}
            </VBtn>
          </div>
        </VCardText>
      </VCard>
    </VDialog>
  </div>
</template>

<script>
import { numberOnly } from "@/utils/inputRegExps";
import Downloader from "@/components/ui/downloader";

const defaultFormData = {
  guessedTakenAwayDate: null,
  body: null,
  orderItemId: null,
  count: null,
  file: null,
};
const defaultOrderItemData = {
  productName: null,
};
export default {
  name: "reception-date-dialog",
  components: { Downloader },
  props: {},
  data() {
    return {
      maxCount: null,
      receptionDialog: false,
      formData: { ...defaultFormData },
      orderItemData: { ...defaultOrderItemData },
      /**
       * @type Array<{filePath:string}>
       */
      listGiven: [],
      dialog: false,
      loading: false,
    };
  },
  methods: {
    close() {
      this.dialog = false;
      this.receptionDialog = false;
      this.formData = { ...defaultFormData };
      this.orderItemData = { ...defaultOrderItemData };
      const { formObs } = this.$refs;
      if (formObs) formObs.reset();
    },
    async open({ id, maxCount, productName }) {
      try {
        this.showLoading();
        const {
          data: { data },
        } = await this.$http.get("produce-history/list", {
          params: { orderItemId: id },
        });
        this.listGiven = data;
        this.formData = {
          ...defaultFormData,
          orderItemId: id,
        };
        this.orderItemData = {
          productName,
        };
        this.maxCount = maxCount;
        this.dialog = true;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    getComment(text) {
      let { guessedTakenAwayDate, count } = this.formData;
      const { productName } = this.orderItemData;
      guessedTakenAwayDate = window
        .moment(guessedTakenAwayDate)
        .format("DD.MM.YYYY");
      if (!text || text.trim() === "") {
        text = this.$t("notificationTemplate.departmentToOmtk", {
          count,
          productName,
          userName: this.userName,
        });
      } else {
        text = `${this.userName}: ${text}`;
      }
      return text + ". " + guessedTakenAwayDate;
    },
    async sendReceptionDate() {
      try {
        this.loading = true;
        const data = { ...this.formData };
        const formData = new FormData();
        formData.append(
          "count",
          data.count.replace(",", ".").replace(/\s/g, "")
        );
        formData.append("body", this.getComment(data.body));
        formData.append("guessedTakenAwayDate", data.guessedTakenAwayDate);
        formData.append("file", data.file);
        formData.append("orderItemId", data.orderItemId);
        await this.$http.post(
          "notification/contract/initiator-to-omtk",
          formData
        );
        this.setSuccess({ text: this.$t("successfullySent") });
        this.close();
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.loading = false;
      }
    },
  },
  computed: {
    numberOnly: () => numberOnly,
    userName() {
      const { firstName, middleName } = this.$store.getters.user;
      return `${middleName} ${firstName}`;
    },
  },
};
</script>
